import { commonStore } from '../global-store/subjects/common';

export const isInjectedHP = () => commonStore.getValue().isInjectedHP;

export const isInjectedHPInView = () => commonStore.getValue().isInjectedHPInView;
